import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticleCTA() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            {t("article.cta.title")}
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base leading-relaxed">
            {t("article.cta.subtitle")}
          </p>
          <Link
            to="/guides/complete-kakobuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("article.cta.button")}
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="relative w-full overflow-hidden">
          <div className="flex gap-4 md:gap-6 justify-center flex-wrap">
            <div className="w-32 md:w-40 h-44 md:h-52 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=White%20minimalist%20sneakers%20isolated%20on%20clean%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20style%2C%20neutral%20warm%20tones%2C%20professional%20catalog%20look%2C%20clean%20simple%20composition%2C%20subtle%20shadow%2C%20elegant%20product%20display&width=300&height=400&seq=cta-prod-1-v2&orientation=portrait"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-32 md:w-40 h-44 md:h-52 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Designer%20hoodie%20isolated%20on%20clean%20warm%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20editorial%20minimalist%20style%2C%20neutral%20beige%20tones%2C%20professional%20look%2C%20clean%20composition%2C%20elegant%20fashion%20display&width=300&height=400&seq=cta-prod-2-v2&orientation=portrait"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-32 md:w-40 h-44 md:h-52 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Luxury%20handbag%20isolated%20on%20clean%20warm%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20neutral%20warm%20tones%2C%20professional%20elegant%20catalog%20look%2C%20clean%20simple%20composition&width=300&height=400&seq=cta-prod-3-v2&orientation=portrait"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-32 md:w-40 h-44 md:h-52 overflow-hidden rounded-lg hidden md:block">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20watch%20isolated%20on%20clean%20warm%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20neutral%20warm%20tones%2C%20professional%20catalog%20look%2C%20elegant%20accessory%20display&width=300&height=400&seq=cta-prod-4-v2&orientation=portrait"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-32 md:w-40 h-44 md:h-52 overflow-hidden rounded-lg hidden lg:block">
              <img
                src="https://readdy.ai/api/search-image?query=Designer%20belt%20isolated%20on%20clean%20warm%20cream%20background%2C%20product%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20editorial%20style%2C%20neutral%20warm%20tones%2C%20professional%20elegant%20look%2C%20clean%20composition&width=300&height=400&seq=cta-prod-5-v2&orientation=portrait"
                alt="Produkt Kakobuy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}